var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import { jsx } from '@emotion/core';
import { BORDER_RADIUS, COLORS, FONT } from '../../constants';
import { labelMargin } from './constants';
var invalidInputStyles = {
  '&[type]': {
    border: "solid 1px " + COLORS.spot.critical,
    boxShadow: 'inset 0 1px 3px 0 rgba(252,76,93,0.40)',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    '&:hover': {
      boxShadow: '0 0 4px rgba(252, 76, 93, 0.6)',
      '&:disabled': {
        boxShadow: 'none'
      }
    }
  }
};
var inputStyles = {
  '&[type]': __assign(__assign({
    display: 'block',
    height: 40,
    width: '100%',
    borderRadius: BORDER_RADIUS.medium,
    color: COLORS.grays.darkest,
    backgroundColor: COLORS.white,
    margin: 0,
    padding: 10,

    /* Reset b2b styleguide */
    appearance: 'none',
    fontFamily: FONT.family
  }, FONT.sizes.regular), {
    boxSizing: 'border-box',
    transition: 'box-shadow 0.2s, border-color 0.2s ease-in-out',
    border: "solid 1px " + COLORS.grays.lighter,
    boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.13)',
    '&:hover': {
      boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
      '&:disabled': {
        boxShadow: 'none'
      }
    },
    '&:focus': {
      border: 'solid 1px #a2d3ff',
      outline: '#a2d3ff',
      boxShadow: '0 0 5px #a2d3ff'
    },
    '&:disabled': {
      background: COLORS.grays["super"],
      border: "solid 1px " + COLORS.grays.lighter,
      color: COLORS.grays.gray,
      cursor: 'not-allowed',
      boxShadow: 'none'
    }
  })
};
var inputWithLabelStyles = {
  '&[type]': {
    margin: labelMargin
  }
};
var inputWithIconStyles = {
  '&[type]': {
    padding: '10px 40px'
  }
};
var inputWithSuffixStyles = {
  '&[type]': {
    display: 'block',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
  }
};
var inputWithPrefixStyles = {
  '&[type]': {
    display: 'block',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0
  }
};
var smallInputStyles = {
  '&[type]': {
    height: 32,
    fontSize: 14
  }
};
var largeInputStyles = {
  '&[type]': {
    height: 48,
    fontSize: 18
  }
};
export var Input = React.forwardRef(function (_a, ref) {
  var _b = _a.errorMessage,
      errorMessage = _b === void 0 ? '' : _b,
      _c = _a.label,
      label = _c === void 0 ? '' : _c,
      icon = _a.icon,
      _d = _a.prefix,
      prefix = _d === void 0 ? '' : _d,
      _e = _a.suffix,
      suffix = _e === void 0 ? '' : _e,
      _f = _a.onChange,
      onChange = _f === void 0 ? function () {} : _f,
      _g = _a.onFocus,
      onFocus = _g === void 0 ? function () {} : _g,
      _h = _a.onBlur,
      onBlur = _h === void 0 ? function () {} : _h,
      _j = _a.size,
      size = _j === void 0 ? 'medium' : _j,
      _k = _a.value,
      value = _k === void 0 ? '' : _k,
      id = _a.id,
      name = _a.name,
      _l = _a.disabled,
      disabled = _l === void 0 ? false : _l,
      _m = _a.placeholder,
      placeholder = _m === void 0 ? '' : _m,
      _o = _a.type,
      type = _o === void 0 ? 'text' : _o,
      className = _a.className,
      _p = _a.autoFocus,
      autoFocus = _p === void 0 ? false : _p,
      _q = _a.onEnterPress,
      onEnterPress = _q === void 0 ? function () {} : _q;
  var isValid = !errorMessage;
  var styles = [inputStyles];
  var onKeyDown = React.useCallback(function (event) {
    if (event.key === 'Enter' && isValid) {
      event.currentTarget.blur();
      onEnterPress(event);
    }
  }, [isValid, onEnterPress]);
  if (!isValid) styles.push(invalidInputStyles);
  if (label) styles.push(inputWithLabelStyles);
  if (icon) styles.push(inputWithIconStyles);
  if (suffix) styles.push(inputWithSuffixStyles);
  if (prefix) styles.push(inputWithPrefixStyles);
  if (size === 'small') styles.push(smallInputStyles);
  if (size === 'large') styles.push(largeInputStyles);
  return jsx("input", {
    className: className,
    type: type,
    ref: ref,
    "data-lpignore": "true",
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    css: styles,
    value: value,
    placeholder: placeholder,
    id: id,
    name: name,
    disabled: disabled,
    autoFocus: autoFocus
  });
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Input/input.js
// module id = 202
// module chunks = 0